import { defineMessages } from 'react-intl'

export default defineMessages({
  addUser: {
    id: 'SpaceMembersPage.AddMember',
    defaultMessage: 'Add Member'
  },
  addUserMessage: {
    id: 'SpaceMembersPage.AddingUserToSpace',
    defaultMessage: 'Adding user to space'
  },
  confirmDelete: {
    id: 'ConfirmDelete',
    defaultMessage: 'Really want to delete?'
  },
  confirmDeleteSubMessage: {
    id: 'SpaceMembersPage.ConfirmDeleteSubMessage',
    defaultMessage: 'This member will be removed from this space'
  },
  email: {
    id: 'Email',
    defaultMessage: 'Email'
  },
  loading: {
    id: 'Loading',
    defaultMessage: 'Loading...'
  },
  loadingMembers: {
    id: 'SpaceMembersPage.LoadingMembers',
    defaultMessage: 'Loading Members'
  },
  name: {
    id: 'Name',
    defaultMessage: 'Name'
  },
  none: {
    id: 'None',
    defaultMessage: 'None'
  },
  noSearchUsers: {
    id: 'SpaceMembersPage.NoSearchUsers',
    defaultMessage:
      'There are no users in this space that match the search criteria. You may need to add the user to the space.'
  },
  noUsers: {
    id: 'SpaceMembersPage.NoUsers',
    defaultMessage: 'Currently there are no users assigned to this space'
  },
  search: {
    id: 'SpaceMembersPage.Search',
    defaultMessage: 'Search'
  },
  removeMemberMessage: {
    id: 'SpaceMembersPage.RemovingMemberFromSpace',
    defaultMessage: 'Removing member from space'
  },
  roles: {
    id: 'SpaceMembersPage.SpaceRoles',
    defaultMessage: 'Roles'
  },
  members: {
    id: 'members',
    defaultMessage: 'members'
  }
})
